import { render, staticRenderFns } from "./TextNoteParametersForm.vue?vue&type=template&id=9da4e498&"
import script from "./TextNoteParametersForm.vue?vue&type=script&lang=js&"
export * from "./TextNoteParametersForm.vue?vue&type=script&lang=js&"
import style0 from "./TextNoteParametersForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports